import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Response } from '../../../../setup/axios/HttpResponse';
import { HTTP_RESPONSE_STATUS } from '../../../../setup/constants/Http';
import { PaymentsApi } from './PaymentsApi';
import { paymentsActions } from './PaymentsSlice';
import {
  CreateZatcaIntegrationRequest,
  RenewZatcaIntegrationRequest,
  ZatcaIntegrationStatus,
  ZatcaOnboardingPrefill,
} from '../models/ZatcaIntegration';

function* getZatcaIntegrationStatus() {
  try {
    const resp: Response<ZatcaIntegrationStatus> = yield call(PaymentsApi.getZatcaIntegrationStatus);
    if (resp.status === HTTP_RESPONSE_STATUS.SUCCESS && resp.data) {
      yield put(paymentsActions.getZatcaIntegrationStatusSuccess(resp.data));
    } else {
      yield put(paymentsActions.getZatcaIntegrationStatusFail());
    }
  } catch (error) {
    yield put(paymentsActions.getZatcaIntegrationStatusFail());
  }
}

function* getZatcaOnboardingPrefill() {
  try {
    const resp: Response<ZatcaOnboardingPrefill> = yield call(PaymentsApi.getZatcaOnboardingPrefill);
    if (resp.status === HTTP_RESPONSE_STATUS.SUCCESS && resp.data) {
      yield put(paymentsActions.getZatcaOnboardingPrefillSuccess(resp.data));
    } else {
      yield put(paymentsActions.getZatcaOnboardingPrefillFail());
    }
  } catch (error) {
    yield put(paymentsActions.getZatcaOnboardingPrefillFail());
  }
}

function* createZatcaIntegration(action: PayloadAction<CreateZatcaIntegrationRequest>) {
  try {
    const resp: Response<ZatcaIntegrationStatus> = yield call(PaymentsApi.createZatcaIntegration, action.payload);
    if (resp.status === HTTP_RESPONSE_STATUS.SUCCESS && resp.data) {
      yield put(paymentsActions.createZatcaIntegrationSuccess(resp.data));
    } else {
      yield put(paymentsActions.createZatcaIntegrationFail(resp.message || 'Failed to complete ZATCA integration.'));
    }
  } catch (error) {
    yield put(paymentsActions.createZatcaIntegrationFail('Failed to complete ZATCA integration.'));
  }
}

function* renewZatcaIntegration(action: PayloadAction<RenewZatcaIntegrationRequest>) {
  try {
    const resp: Response<ZatcaIntegrationStatus> = yield call(PaymentsApi.renewZatcaIntegration, action.payload);
    if (resp.status === HTTP_RESPONSE_STATUS.SUCCESS && resp.data) {
      yield put(paymentsActions.renewZatcaIntegrationSuccess(resp.data));
    } else {
      yield put(paymentsActions.renewZatcaIntegrationFail(resp.message || 'Failed to renew ZATCA registration.'));
    }
  } catch (error) {
    yield put(paymentsActions.renewZatcaIntegrationFail('Failed to renew ZATCA registration.'));
  }
}

export default function* paymentsSaga() {
  yield takeLatest(paymentsActions.getZatcaIntegrationStatus, getZatcaIntegrationStatus);
  yield takeLatest(paymentsActions.getZatcaOnboardingPrefill, getZatcaOnboardingPrefill);
  yield takeLatest(paymentsActions.createZatcaIntegration, createZatcaIntegration);
  yield takeLatest(paymentsActions.renewZatcaIntegration, renewZatcaIntegration);
}
